import { Component, OnInit } from "@angular/core";
import { AppService } from "../../services/app.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-patient-info-sidenav",
  templateUrl: "./patient-info-sidenav.component.html",
})
export class PatientInfoSidenavComponent implements OnInit {
  selectedlang: any = {};
  tcCode = "";
  testCenterName = "";
  currentURL: any = "";
  isUSBased = false;
  constructor(private router: Router, private appservice: AppService) {}

  ngOnInit() {
    if (localStorage.getItem("testCode") != null) {
      this.tcCode = localStorage.getItem("testCode").toString();
    }

    if (localStorage.getItem("testCenterName") != null) {
      this.testCenterName = localStorage.getItem("testCenterName");
    }

    // Check if image center is US-based (countryId = 2)
    const countryId = localStorage.getItem("countryId");
    this.isUSBased = countryId === "2";

    this.appservice.getlang().subscribe((res) => {
      this.selectedlang = res["header"];
    });
    if (sessionStorage.getItem("type")) {
      this.checkURL(sessionStorage.getItem("type"));
    } else {
      this.checkURL("schedule-appointment");
    }
  }

  checkURL(type) {
    sessionStorage.setItem("type", type);
    if (type != null && localStorage.getItem("testCode") != null) {
      if (this.router.url) {
        const url = this.router.url.toString().trim().split("/");
        this.currentURL = url[2];
      }
      if (!this.router.url) {
        setTimeout(() => {
          const url = this.router.url.toString().trim().split("/");
          this.currentURL = url[1];
        }, 100);
      }
    }
  }
}
